module.exports = __webpack_public_path__ + "static/media/login-illustration.b14dc8ad.jpg";